import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibo el material?',
  answer: '100% digital (PDF descargables) listos para usar desde cualquier dispositivo. Acceso inmediato a todo el contenido.'
}, {
  question: '¿Puedo imprimir las clases y actividades?',
  answer: '¡Sí! Todo el material está diseñado para ser impreso fácilmente. Podés imprimir las clases, actividades, evaluaciones y todo lo que necesites para tu aula.'
}, {
  question: '¿Para qué años de secundaria sirve?',
  answer: 'El material está pensado para todos los años de secundaria donde se dicte Política y Ciudadanía. Incluye contenidos adaptables según el nivel y los diseños curriculares vigentes.'
}, {
  question: '¿Las actividades son difíciles de implementar?',
  answer: 'Para nada. Todas las actividades vienen con instrucciones claras, paso a paso, y están diseñadas para funcionar en el aula real. Solo tenés que abrir el archivo y empezar.'
}, {
  question: '¿Cuánto tarda en llegar el acceso?',
  answer: 'El acceso es inmediato. Una vez que completás la compra, recibís un email con el enlace de descarga. En minutos ya tenés todo el material disponible.'
}, {
  question: '¿Hay actualizaciones incluidas?',
  answer: 'Sí, todas las actualizaciones futuras están incluidas sin costo adicional. Cuando mejoremos o agreguemos contenido, vas a recibir acceso automático.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-16 px-4 sm:px-6 lg:px-8" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <div className="text-center mb-12" data-id="element-60">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#1e3a5a] rounded-full mb-4" data-id="element-61">
            <HelpCircle className="w-8 h-8 text-[#d4a853]" data-id="element-62" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5a] mb-2" data-id="element-63">
            Preguntas Frecuentes
          </h2>
          <p className="text-gray-600" data-id="element-64">
            Todo lo que necesitás saber sobre POLÍTICA Y CIUDADANÍA 360
          </p>
        </div>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, index) => <div key={index} className="bg-[#FDF6E3] rounded-xl border border-[#d4a853]/20 overflow-hidden" data-id="element-66">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 hover:bg-[#f5edd8] transition-colors" data-id="element-67">
                <span className="font-semibold text-[#1e3a5a] text-lg" data-id="element-68">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#d4a853] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-69" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-70">
                <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-71">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}